import {Box, HBox} from '../../../../components/core/view';
import {CustomText, H5Text, PSmallText} from '../../../../components/core/text';
import React, {useCallback, useMemo} from 'react';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../appStyles/hooks/theme';

import AppModal from '../../../../common/components/CustomModal/AppModal';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {styles} from './style';
import {useGetLocale} from '@buncha/localization/hooks';

interface OrganicReminderModalProps {
  open: boolean;
  onClose: Function;
  isOrganic: boolean;
  isGlutenFree: boolean;
}

const OrganicReminderModal: React.FC<OrganicReminderModalProps> = props => {
  const {isOrganic, isGlutenFree} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const {title, body, button} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};
  const reminderContent = useMemo(() => {
    if (isOrganic && isGlutenFree)
      return {
        title: title?.organicAndGF,
        subtitle: body?.organicModal?.organicAndGF,
      };

    if (isOrganic)
      return {
        title: title?.organic,
        subtitle: body?.organicModal?.organic,
      };

    if (isGlutenFree)
      return {
        title: title?.glutenFree,
        subtitle: body?.organicModal?.glutenFree,
      };
  }, [
    body?.organicModal?.glutenFree,
    body?.organicModal?.organic,
    body?.organicModal?.organicAndGF,
    isGlutenFree,
    isOrganic,
    title?.glutenFree,
    title?.organic,
    title?.organicAndGF,
  ]);

  const handleClose = useCallback(() => {
    props?.onClose();
  }, [props]);
  return (
    <AppModal
      isOpen={props?.open}
      onClose={() => props?.onClose()}
      topCTAHandelr={handleClose}
      title={title?.reminder}
      hideBottomCta
      modalBody={
        <Box>
          <HBox style={styles.modalBody}>
            <H5Text>
              {isOrganic && !isGlutenFree
                ? body?.organicModal?.thisIsAn
                : body?.organicModal?.thisIsA}
            </H5Text>

            <HBox
              style={[
                styles.highlightText,
                {
                  backgroundColor: theme?.background?.orange?.[100],
                },
              ]}>
              <CustomText
                style={{
                  fontFamily: muliFont[700].normal,
                  color: theme?.text?.white?.[100],
                }}>
                {reminderContent?.title}
              </CustomText>
            </HBox>
            <H5Text>{body?.organicModal?.item}</H5Text>
          </HBox>
          <PSmallText
            style={{
              fontFamily: muliFont[700].normal,
              color: theme?.text.red[100],
            }}>
            {reminderContent?.subtitle}
          </PSmallText>
        </Box>
      }
      ctaTopTitle={button?.ok}
      topCTAColor={theme?.background.green[100]}
    />
  );
};

export default React.memo(OrganicReminderModal);
